var exports = {
  "g4": "AuthPageStyles.module__loadingContainer___SGc5am",
  "Un": "AuthPageStyles.module__errorContainer___SGc5am",
  "ik": "AuthPageStyles.module__errorIcon___SGc5am",
  "gi": "AuthPageStyles.module__errorIconSvg___SGc5am",
  "JU": "AuthPageStyles.module__errorTitle___SGc5am",
  "kc": "AuthPageStyles.module__errorText___SGc5am",
  "kL": "AuthPageStyles.module__container___SGc5am",
  "zm": "AuthPageStyles.module__loginHeader___SGc5am",
  "TQ": "AuthPageStyles.module__entityHeader___SGc5am",
  "Ep": "AuthPageStyles.module__entityDetails___SGc5am",
  "Pp": "AuthPageStyles.module__entityText___SGc5am",
  "j2": "AuthPageStyles.module__entityTitleWrapper___SGc5am",
  "wD": "AuthPageStyles.module__entityTitle___SGc5am",
  "N2": "AuthPageStyles.module__entityStats___SGc5am",
  "So": "AuthPageStyles.module__entityStat___SGc5am",
  "RS": "AuthPageStyles.module__onlineDot___SGc5am",
  "FD": "AuthPageStyles.module__offlineDot___SGc5am",
  "KA": "AuthPageStyles.module__statText___SGc5am",
  "Wp": "AuthPageStyles.module__entityIconWrapper___SGc5am",
  "fq": "AuthPageStyles.module__entityIcon___SGc5am",
  "Ly": "AuthPageStyles.module__themeIconSpot___SGc5am",
  "J3": "AuthPageStyles.module__themeIcon___SGc5am",
  "Zd": "AuthPageStyles.module__form___SGc5am",
  "ee": "AuthPageStyles.module__registrationNotice___SGc5am",
  "Gr": "AuthPageStyles.module__bottomLink___SGc5am",
  "fH": "AuthPageStyles.module__bottomLinkText___SGc5am",
  "J5": "AuthPageStyles.module__bottomLinkAnchor___SGc5am",
  "cB": "AuthPageStyles.module__usernameHint___SGc5am",
  "Jy": "AuthPageStyles.module__suggestionLink___SGc5am",
  "LB": "AuthPageStyles.module__usernameError___SGc5am",
  "up": "AuthPageStyles.module__legalNotice___SGc5am",
  "Rf": "AuthPageStyles.module__policyLink___SGc5am",
  "ii": "AuthPageStyles.module__disabledContainer___SGc5am",
  "aV": "AuthPageStyles.module__disabledText___SGc5am",
  "ax": "AuthPageStyles.module__disabledSubtext___SGc5am",
  "SO": "AuthPageStyles.module__disabledActions___SGc5am",
  "ns": "AuthPageStyles.module__disabledActionLink___SGc5am",
  "DD": "AuthPageStyles.module__title___SGc5am",
  "Zo": "AuthPageStyles.module__giftIconContainer___SGc5am",
  "ez": "AuthPageStyles.module__giftIcon___SGc5am",
  "PM": "AuthPageStyles.module__entitySubtext___SGc5am",
  "W$": "AuthPageStyles.module__subtext___SGc5am",
  "$0": "AuthPageStyles.module__consentLine___SGc5am",
};

module.exports = exports;
